module.exports = __webpack_public_path__ + "media/images/review/star_4-255cca98211f1d5c0dc808bc627443e7.svg";